/* 2.11 (uwagi Łukasza HOME-008, PROD-009): strzałki przewijanych rzędów produktów (Bestsellery, Skompletuj zestaw)
   NAD rzędem, w nagłówku sekcji — nie na zdjęciach. Pasek przewijania na komputerze schowany (na Windowsie Chrome
   rysował przy nim strzałki pod kartami). Na telefonie bez strzałek, zostaje przesuwanie palcem. */
(function () {
  if (window.__slRowArrows) return;
  window.__slRowArrows = true;
  var SEL = '.sl-rowslider, .sl-track';
  function setup(track) {
    if (track.dataset.slArr) return;
    track.dataset.slArr = '1';
    var head = null, wrap = track.parentElement;
    for (var el = track.previousElementSibling; el; el = el.previousElementSibling) {
      if (el.classList && el.classList.contains('mk-sec-head')) { head = el; break; }
    }
    var box = document.createElement('div');
    box.className = 'sl-rarr';
    box.innerHTML = '<button type="button" class="sl-rarr__b" data-dir="-1" aria-label="‹">‹</button><button type="button" class="sl-rarr__b" data-dir="1" aria-label="›">›</button>';
    if (head) head.appendChild(box); else wrap.insertBefore(box, track);
    track.classList.add('sl-has-arr');
    var prev = box.children[0], next = box.children[1];
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; }
    function sync() {
      var can = track.scrollWidth > track.clientWidth + 4;
      box.hidden = !can;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    [prev, next].forEach(function (b) {
      b.addEventListener('click', function () {
        var from = track.scrollLeft, d = step() * 2 * (+b.dataset.dir);
        track.scrollBy({ left: d, behavior: 'smooth' });
        setTimeout(function () { if (Math.abs(track.scrollLeft - from) < 2) track.scrollLeft = from + d; }, 350);
      });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    document.addEventListener('click', function () { setTimeout(sync, 80); });
    setTimeout(sync, 60);
  }
  function init() { document.querySelectorAll(SEL).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
